var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.33,
    height: 25.142,
    viewBox: "0 0 38.33 25.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #494ca3;\n      }\n\n      .cls-3 {\n        fill: #ffc000;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e59703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#e59703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#5457bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5457bb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(-1506.728 -4066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_327",
    "data-name": "Shape 327",
    className: "cls-1",
    d: "M1508.395,4889.874h35a1.7,1.7,0,0,1,1.667,1.734v21.674a1.7,1.7,0,0,1-1.667,1.734h-35a1.7,1.7,0,0,1-1.667-1.734v-21.674A1.7,1.7,0,0,1,1508.395,4889.874Z",
    transform: "translate(0 -823.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_328",
    "data-name": "Shape 328",
    className: "cls-2",
    d: "M1536.7,4907.1l-.252-1.295h-2.734l-.449,1.295h-2.242l3.207-8.065a1,1,0,0,1,.993-.649h1.729l1.722,8.715Zm-1.236-6.344-1.13,3.261h1.766Zm-7.287.114c0,.952,3,1.156,3,3.345,0,2.108-2.215,2.883-3.682,2.883a5.931,5.931,0,0,1-2.428-.476l.32-1.89c.88.72,3.549.925,3.549-.218s-2.975-1.17-2.975-3.346c0-2.312,2.534-2.788,3.6-2.788a6.106,6.106,0,0,1,1.934.367l-.307,1.809C1530.27,4900.044,1528.175,4899.922,1528.175,4900.874Zm-6.584,6.23,1.344-8.715h2.151l-1.344,8.715Zm-5.157,0-1.866-7.562a8.135,8.135,0,0,1,.941.686,6.825,6.825,0,0,1,1.981,2.865h0l.243,1.291,2.051-5.994h2.315l-3.422,8.715Zm-3.794-8.476-.1-.03Zm-.22-.065-.048-.013Zm.529.17-.128-.045Zm1.491.725q-.1-.062-.2-.119C1514.306,4899.379,1514.372,4899.417,1514.44,4899.459Zm-.514-.29c-.058-.03-.118-.062-.175-.09C1513.808,4899.107,1513.867,4899.139,1513.926,4899.169Zm-.535-.257-.118-.051Z",
    transform: "translate(0 -823.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_328-2",
    "data-name": "Shape 328",
    className: "cls-3",
    d: "M1517.489,4903.093l-.724-3.918a.939.939,0,0,0-1.02-.785h-3.39l-.04.147a8.146,8.146,0,0,1,3.192,1.69A6.825,6.825,0,0,1,1517.489,4903.093Z",
    transform: "translate(0 -823.874)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0f5a6a99a9baf5e6f79cfa9f26673387.svg";
export { ForwardRef as ReactComponent };